var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFffTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.076,
    y1: 20,
    x2: 163.1773,
    y2: 20,
    gradientTransform: "matrix(1 0 0 -1 0 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C47DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDBCD4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,10.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.9,0.5-1.8,0.8-2.7,1c-0.2,0.1-0.4,0-0.6-0.1c-1.1-1-2.4-1.5-3.9-1.4 c-1.7,0.1-3.1,0.8-4,2.2c-0.7,0.9-1,2-0.9,3.1c0,0.3,0.1,0.6,0.1,0.9c-4.4-0.3-8-2.1-10.8-5.3c-0.5,0.9-0.8,1.9-0.7,3.1 c0.2,1.5,0.9,2.7,2.2,3.7c-0.8,0-1.6-0.2-2.3-0.6c-0.1,1.6,1,4.3,4.1,5.1c-0.4,0.1-0.7,0.1-1.1,0.1s-0.8,0-1.2,0 c0.9,2.2,2.5,3.3,4.9,3.5c-2.3,1.7-4.8,2.3-7.7,2.1c0.1,0,0.1,0.1,0.1,0.1c1.8,1.1,3.8,1.8,6,2.1c1.9,0.2,3.7,0.1,5.5-0.3 c2-0.4,3.8-1.3,5.5-2.5c1.8-1.3,3.2-3,4.2-5c1.2-2.2,1.7-4.6,1.7-7.1c0-0.1,0-0.2,0.2-0.3c0.7-0.5,1.3-1.1,1.8-1.7 c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.4c-0.9,0.3-1.9,0.6-2.8,0.7C30.9,12.4,31.7,11.5,32.1,10.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFffTwitter);
export default __webpack_public_path__ + "static/media/fff-twitter.194ea7f3adc9042ac0f95d1343b91879.svg";
export { ForwardRef as ReactComponent };